import { ActivatedRouteSnapshot } from '@angular/router';

/** Route data flag: the page renders its own navbar/footer (e.g. the v3 home page). */
export const HIDE_SHELL = 'hideShell';

/**
 * Whether the global v2 navbar/footer should be hidden for a resolved route.
 * Document viewer routes are always chrome-less; any route can opt out via `data.hideShell`.
 */
export function isShellHidden(url: string, root: ActivatedRouteSnapshot): boolean {
  if (url.startsWith('/documents/')) {
    return true;
  }
  let node: ActivatedRouteSnapshot | null = root;
  while (node) {
    if (node.data?.[HIDE_SHELL] === true) {
      return true;
    }
    node = node.firstChild;
  }
  return false;
}
